import { render } from "./Multiselect.vue?vue&type=template&id=b5b7ba82&ts=true&lang=pug"
import script from "./Multiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./Multiselect.vue?vue&type=script&setup=true&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__